import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

class HomeSwiper {
    private swiperContainer: HTMLElement | null;
    private swiperWrapper?: HTMLElement | null;
    private readonly MIN_SLIDES_FOR_LOOP = 9;

    constructor() {
        this.swiperContainer = document.querySelector('.slider');

        if (!this.swiperContainer) {
            return;
        }
        this.swiperWrapper = this.swiperContainer.querySelector(':scope > div:first-child');
        if (this.swiperWrapper) {
            this.prepareSwiperStructure();
            this.duplicateSlides();
            this.initSwiper();
        }
    }
    private prepareSwiperStructure(): void {
        if (!this.swiperContainer || !this.swiperWrapper) return;

        // Ajout des classes nécessaires
        this.swiperContainer.classList.add('swiper');
        this.swiperWrapper.classList.add('swiper-wrapper');

        const slides = this.swiperWrapper.querySelectorAll(':scope > .wp-block-group');
        slides.forEach(slide => {
            slide.classList.add('swiper-slide');
        });
    }

    private duplicateSlides(): void {
        if (!this.swiperWrapper) return;

        const originalSlides = Array.from(
            this.swiperWrapper.querySelectorAll('.swiper-slide')
        );

        const currentSlideCount = originalSlides.length;
        if (currentSlideCount < this.MIN_SLIDES_FOR_LOOP) {
            let slidesToCopy = 0;
            let totalSlidesAfterCopy = currentSlideCount;
            while (totalSlidesAfterCopy < currentSlideCount * 2) {
                slidesToCopy += currentSlideCount;
                totalSlidesAfterCopy += currentSlideCount;
            }
            let duplicateCount = 0;
            while (duplicateCount < slidesToCopy) {
                const slideToClone = originalSlides[duplicateCount % currentSlideCount];
                const clonedSlide = slideToClone.cloneNode(true) as HTMLElement;
                this.swiperWrapper.appendChild(clonedSlide);
                duplicateCount++;
            }

        }
    }

    private initSwiper(): void {
        if (!this.swiperContainer || !this.swiperWrapper) return;
        new Swiper(this.swiperContainer, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            allowTouchMove: true,
            mousewheel: true,
            spaceBetween: 0,
            centeredSlides: false,
            loop: true,
            speed: 15000,
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            },
            on: {
                setTranslate: function (swiper) {
                    if (swiper.translate < swiper.maxTranslate()) {
                        //  swiper.setTransition(0);
                        swiper.setTranslate(0);
                        if (swiper.autoplay.running) {
                            swiper.autoplay.start();
                        }
                    }
                }
            }
        });

    }
}

document.addEventListener('DOMContentLoaded', () => {
    new HomeSwiper();
});